const awsConfiguration = {
  region: "ap-northeast-1",
  UserPoolId: "ap-northeast-1_rjuUh93Nt",
  ClientId: "70r4ppnot46mhgn6krepnvsi64"
}
export default awsConfiguration
